/**
 * How wide the sidebar is - the one number the whole app layout is built
 * around.
 *
 * Three places have to agree on it: the sidebar itself, and the content
 * wrapper's width AND left margin, which are what keep the page from sliding
 * under it. They were three literals before, so changing the width meant
 * finding all of them and getting the `calc()` right by hand.
 *
 * Strings rather than numbers because every use is inside a CSS template, and
 * `calc(100% - ${SIDEBAR_WIDTH})` reads better than an arithmetic dance.
 */
export const SIDEBAR_WIDTH = '280px';

/** Collapsed: wide enough for the icon discs and nothing else. */
export const SIDEBAR_WIDTH_COLLAPSED = '85px';
